import PropTypes from 'prop-types';
import React from 'react';

import Menu from 'ui-library/menus/Menu';
import {MenuHeight, MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';
import Section from 'ui-library/menus/Section';
import {ElementMouseEvent} from 'util/Types';

export default function StageFlowNodeDropdownMenu(props: StageFlowNodeDropdownMenuProps): JSX.Element {
  const {
    onClickSetParent,
    onRemoveNode,
    onRemoveNodeAndDownstreamNodes,
    onClickDuplicateTree,
    onClickExplodeTree,
    onClickSetExperimentalCondition,
    openSetExperimentalConditionDisabled,
  } = props;

  return (
    <Menu height={MenuHeight.MEDIUM} width={MenuWidth.MEDIUM}>
      <Section>
        <Option
          isDisabled={openSetExperimentalConditionDisabled}
          onSelect={(_value, e) => {
            onClickSetExperimentalCondition(e);
          }}
        >
          Set experimental conditions
        </Option>
        <Option
          onSelect={(_value, e) => {
            onClickSetParent(e);
          }}
        >
          Select input source
        </Option>
      </Section>
      <Section>
        <Option
          onSelect={(_value, e) => {
            onClickDuplicateTree(e);
          }}
        >
          Duplicate branch
        </Option>
        <Option
          onSelect={(_value, e) => {
            onClickExplodeTree(e);
          }}
        >
          Split by conditions
        </Option>
      </Section>
      <Section>
        <Option
          onSelect={(_value, e) => {
            onRemoveNode(e);
          }}
        >
          Delete run
        </Option>
        <Option
          onSelect={(_value, e) => {
            onRemoveNodeAndDownstreamNodes(e);
          }}
        >
          Delete this and all downstream runs
        </Option>
      </Section>
    </Menu>
  );
}

interface StageFlowNodeDropdownMenuProps {
  onClickSetParent: (e: ElementMouseEvent) => void;
  onRemoveNode: (e: ElementMouseEvent) => void;
  onClickDuplicateTree: (e: ElementMouseEvent) => void;
  onClickExplodeTree: (e: ElementMouseEvent) => void;
  onRemoveNodeAndDownstreamNodes: (e: ElementMouseEvent) => void;
  onClickSetExperimentalCondition: (e: ElementMouseEvent) => void;
  openSetExperimentalConditionDisabled: boolean;
}

StageFlowNodeDropdownMenu.propTypes = {
  onClickSetParent: PropTypes.func.isRequired,
  onRemoveNode: PropTypes.func.isRequired,
  onClickDuplicateTree: PropTypes.func.isRequired,
  onClickExplodeTree: PropTypes.func.isRequired,
  onRemoveNodeAndDownstreamNodes: PropTypes.func.isRequired,
  onClickSetExperimentalCondition: PropTypes.func.isRequired,
  openSetExperimentalConditionDisabled: PropTypes.bool.isRequired,
};
